module.exports = __webpack_public_path__ + "img/c9e8142.jpg";